import React, { useState, useEffect } from 'react';
import { Layout, ConfigProvider, theme } from 'antd';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import zhCN from 'antd/locale/zh_CN';
import AppHeader from './components/Header';
import AppFooter from './components/Footer';
import HomePage from './pages/Home';
import AuthPage from './pages/Auth';
import AboutPage from './pages/About';
import ArchivePage from './pages/Archive';
import PostDetailPage from './pages/PostDetail';
import WritePostPage from './pages/WritePost';
import NotFoundPage from './pages/NotFound';
import './App.css';

// 路由守卫组件
const PrivateRoute = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      setCurrentUser(JSON.parse(userStr));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <Layout style={{ minHeight: '100vh', justifyContent: 'center', alignItems: 'center' }}>
        <div>加载中...</div>
      </Layout>
    );
  }

  if (!currentUser) {
    // 保存当前路径，登录后跳转回来
    return <Navigate to={`/auth?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return children;
};

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // 检查用户主题偏好
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const savedTheme = localStorage.getItem('theme');
    
    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setDarkMode(true);
    }
  }, []);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
    localStorage.setItem('theme', !darkMode ? 'dark' : 'light');
  };

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
          colorBgLayout: darkMode ? '#141414' : '#f0f2f5',
        },
        components: {
          Layout: {
            headerBg: darkMode ? '#1f1f1f' : '#001529',
            bodyBg: darkMode ? '#141414' : '#f0f2f5',
          },
          Card: {
            borderRadiusLG: 8,
            boxShadowTertiary: '0 2px 8px rgba(0, 0, 0, 0.06)',
          },
          Button: {
            borderRadius: 6,
          },
        },
      }}
    >
      <Router>
        <Layout className="app-layout">
          <AppHeader darkMode={darkMode} toggleTheme={toggleTheme} />
          <Layout.Content className="app-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/archive" element={<ArchivePage />} />
              <Route path="/post/:id" element={<PostDetailPage />} />
              <Route 
                path="/write" 
                element={
                  <PrivateRoute>
                    <WritePostPage />
                  </PrivateRoute>
                } 
              />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout.Content>
          <AppFooter />
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;